module.exports = __webpack_public_path__ + "static/media/home-bg.4c5099d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-bg.jpg
// module id = 782
// module chunks = 0